import React, { useState, useEffect } from "react";

const CategoryManagement = () => {
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState({
    name_en: "",
    name_fr: "",
    name_de: "",
    name_es: "",
    name_it: "",
  });

  const reloadCategories = () => {
    // Fetch categories from API
    fetch("/api/category")
      .then((response) => response.json())
      .then((data) => {
        setCategories(data);
      })
      .catch((error) => {
        console.error("There was an error fetching the categories!", error);
      });
  };

  useEffect(() => {
    reloadCategories();
  }, []);

  const handleAddCategory = () => {
    if (Object.values(newCategory).some((name) => name.trim() === "")) return;

    // Add new category to API
    fetch("/api/category", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newCategory),
    })
      .then((response) => response.json())
      .then((data) => {
        setCategories([...categories, data]);
        setNewCategory({
          name_en: "",
          name_fr: "",
          name_de: "",
          name_es: "",
          name_it: "",
        });
      })
      .catch((error) => {
        console.error("There was an error adding the category!", error);
      });
  };

  const handleDeleteCategory = (id) => {
    // Delete category from API
    if (!window.confirm("Are you sure you want to delete this categories?")) {
      return;
    }
    fetch(`/api/category/${id}`, {
      method: "DELETE",
    })
      .then(() => {
        setCategories(categories.filter((category) => category.id !== id));
      })
      .catch((error) => {
        console.error("There was an error deleting the category!", error);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewCategory((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleChangeCategory = (e, category) => {
    const { name, value } = e.target;
    const updatedCategory = { ...category, [name]: value };

    setCategories((prevState) =>
      prevState.map((categoryt) =>
        categoryt.id === category.id ? updatedCategory : categoryt
      )
    );

    fetch(`/api/category/${category.id}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ [name]: value }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        if (name === "priority") {
          reloadCategories();
        }
      })
      .catch((error) => {
        console.error("There was an error updating the category!", error);
      });
  };

  return (
    <div className="p-4">
      <button
        className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline mb-4"
        type="button"
        onClick={() => (window.location.href = "/admin/dashboard")}
      >
        Go Back
      </button>
      <h1 className="text-2xl font-bold mb-4">Category Management</h1>
      <div className="mb-4">
        {["en", "fr", "de", "es", "it"].map((lang) => (
          <input
            key={lang}
            type="text"
            name={`name_${lang}`}
            value={newCategory[`name_${lang}`]}
            onChange={handleChange}
            placeholder={`New Category (${lang.toUpperCase()})`}
            className="border p-2 mr-2 text-gray-800 mb-2"
          />
        ))}
        <button
          onClick={handleAddCategory}
          className="bg-blue-500 text-white p-2 rounded"
        >
          Add Category
        </button>
      </div>
      <table className="min-w-full">
        <thead>
          <tr>
            <th className="py-2">EN</th>
            <th className="py-2">FR</th>
            <th className="py-2">DE</th>
            <th className="py-2">ES</th>
            <th className="py-2">IT</th>
            <th className="py-2">Priority</th>
            <th className="py-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {categories.map((category) => (
            <tr key={category.id} className="border-t">
              <td className="py-2">
                <input
                  type="text"
                  name="name_en"
                  value={category.name_en}
                  onChange={(e) => handleChangeCategory(e, category)}
                  className="border p-2 text-gray-800"
                />
              </td>
              <td className="py-2">
                <input
                  type="text"
                  name="name_fr"
                  value={category.name_fr}
                  onChange={(e) => handleChangeCategory(e, category)}
                  className="border p-2 text-gray-800"
                />
              </td>
              <td className="py-2">
                <input
                  type="text"
                  name="name_de"
                  value={category.name_de}
                  onChange={(e) => handleChangeCategory(e, category)}
                  className="border p-2 text-gray-800"
                />
              </td>
              <td className="py-2">
                <input
                  type="text"
                  name="name_es"
                  value={category.name_es}
                  onChange={(e) => handleChangeCategory(e, category)}
                  className="border p-2 text-gray-800"
                />
              </td>
              <td className="py-2">
                <input
                  type="text"
                  name="name_it"
                  value={category.name_it}
                  onChange={(e) => handleChangeCategory(e, category)}
                  className="border p-2 text-gray-800"
                />
              </td>
              <td className="py-2">
                <input
                  type="number"
                  name="priority"
                  value={category.priority || 0}
                  onChange={(e) => handleChangeCategory(e, category)}
                  className="border p-2 text-gray-800"
                />
              </td>
              <td className="py-2">
                <button
                  onClick={() => handleDeleteCategory(category.id)}
                  className="bg-red-500 text-white p-2 rounded mr-2"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CategoryManagement;
